import { render, staticRenderFns } from "./DeviceCommsView.vue?vue&type=template&id=d1a8a09c&lang=html"
import script from "./DeviceCommsView.vue?vue&type=script&lang=js"
export * from "./DeviceCommsView.vue?vue&type=script&lang=js"
import style0 from "./DeviceCommsView.vue?vue&type=style&index=0&id=d1a8a09c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports